import { ACCOUNT_STATUS, AdminUser, IBrand } from "@shared/lib/types";
import styles from "./styles.module.scss";
import { Space, Image, Tag, Rate, Avatar } from "antd";
import { CopyOutlined, EditOutlined } from "@ant-design/icons";
import {
  IInfluencer,
  INFLUENCER_ACCOUNT_STATUS,
} from "@shared/lib/types/influencer";
import { Agency } from "@shared/lib/types/agency";
import { Button } from "@shared/ui/Button";
import { ToastService } from "@shared/lib/services";

interface Props {
  agency: Agency;
  handleEditClick: () => void;
}

export function AgencyCard({ agency, handleEditClick }: Props) {
  return (
    <div className={styles.card}>
      <Space
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
          padding: "10px 0",
        }}
      >
        <Space
          style={{
            gap: 20,
          }}
        >
          <Avatar src={agency.profilePicUrl} className={styles.image} />
          <div className={styles.nameGrid}>
            <div>
              <div className={styles.name}>{agency.name}</div>
              <div className={styles.permItemDesc}>{agency.companyName}</div>
              <div className={styles.permItemDesc}>
                Agency Id:{" "}
                <Button
                  type="link"
                  icon={<CopyOutlined />}
                  iconPosition="end"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(agency._id);
                    ToastService.success("Agency Id Copied");
                  }}
                >
                  {agency._id}
                </Button>
              </div>
            </div>
            <Rate disabled value={agency.avgReview} />
          </div>
        </Space>
        <div style={{ display: "grid", gap: "5px" }}>
          <Tag color="grey" style={{ width: "max-content" }}>
            Agency
          </Tag>

          <Tag
            color={agency.type === "Company" ? "blue" : "green"}
            style={{ width: "max-content" }}
          >
            {agency?.type || "Company"}
          </Tag>
        </div>
      </Space>
      <div className={styles.footer}>
        <EditOutlined className={styles.icon} onClick={handleEditClick} />
      </div>
    </div>
  );
}
